import { render } from "./SetQx.vue?vue&type=template&id=fb934336&scoped=true"
import script from "./SetQx.vue?vue&type=script&lang=js"
export * from "./SetQx.vue?vue&type=script&lang=js"

import "./SetQx.vue?vue&type=style&index=0&id=fb934336&lang=less"
import "./SetQx.vue?vue&type=style&index=1&id=fb934336&scoped=true&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb934336"]])

export default __exports__